var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"NavMenuItem"},[_c('router-link',{staticClass:"waves-effect waves-dark",class:[{ 'router-link-active': _vm.jaActiveLink(_vm.$route.meta.sidebar.parent) }],attrs:{"to":_vm.to,"exact":"","aria-expanded":"false"}},[_c('i',{class:_vm.classIcon}),_c('span',[_vm._v(_vm._s(_vm.jaGetRouteParam(_vm.name)))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }